import { render } from "./GeneralSettings.vue?vue&type=template&id=3266a4d3&scoped=true"
import script from "./GeneralSettings.vue?vue&type=script&lang=js"
export * from "./GeneralSettings.vue?vue&type=script&lang=js"

import "./GeneralSettings.vue?vue&type=style&index=0&id=3266a4d3&lang=css&scoped=true"

import exportComponent from "E:\\wamp64\\www\\law-firm-system-vue\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3266a4d3"]])

export default __exports__